export default __webpack_public_path__ + "static/media/@chavedasdivas.8243fb18.jpg";